var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 611,
    height: 265,
    viewBox: "0 0 611 265",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.199 109.616H140.23V155.391H149.379C163.922 155.391 175.035 146.581 175.035 132.502C175.035 119.905 164.742 109.613 150.199 109.613M151.015 160.162H135V104.838H151.015C167.193 104.838 180.265 116.53 180.265 132.502C180.265 148.717 167.275 160.162 151.015 160.162Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400.533 160.162L364.022 113.317V160.162H358.809V104.838H364.022L400.533 151.679V104.838H405.75V160.162H400.533Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M448.5 109.093C435.686 109.093 425.257 119.686 425.257 132.5C425.257 145.31 435.69 155.904 448.5 155.904C461.314 155.904 471.743 145.31 471.743 132.5C471.743 119.686 461.314 109.093 448.5 109.093ZM448.5 161C432.731 161 420 148.272 420 132.5C420 116.731 432.728 104 448.5 104C464.269 104 477 116.731 477 132.5C477 148.269 464.272 161 448.5 161Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.162 160.162V104.838H253.453V155.387H286.721V160.162H248.162Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.516 160.162V104.838H232.249V109.613H199.807V128.546H226.543V133.32H199.807V155.387H233.074V160.162H194.516Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.087 112.413L310.146 138.508H332.027L321.087 112.413ZM341.091 160.162L333.989 143.286H308.188L301.086 160.162H295.941L319.129 104.838H323.048L346.236 160.162H341.091Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelano);
export default __webpack_public_path__ + "static/media/delano.e6f506a235ffc75478a85972a1edd8cb.svg";
export { ForwardRef as ReactComponent };